<template>
  <span
    v-for="(error, i) in theErrors"
    :key="error.name + i"
    class="validation"
    >{{ error.value }}</span
  >
</template>

<script lang="ts" setup>
import { computed, ComputedRef } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: "",
  },
  errors: {
    type: Array,
    //default value for 'errors' prop must be a function
    default: () => [],
  },
});

const theErrors: ComputedRef<any[]> = computed(() => {
  return props.errors.filter((error: any) => {
    return error.name == props.name;
  });
});
</script>
